// Anchos de las columnas de la hoja.
//
// Cada columna tiene un ancho FIJO: el que ajuste el usuario (arrastrando el borde) o
// uno por defecto según la columna o su tipo. El contenido nunca cambia el ancho: lo
// que no cabe se corta con puntos suspensivos y se ve entero al pasar el ratón.
// El doble clic en el borde ajusta la columna al texto más largo de TODAS las obras
// (computeColumnWidth) y ese ancho queda fijado como el del usuario.

// Columnas congeladas (casilla, nº, código, tienda) y columnas especiales.
export const FIXED_COLUMN_WIDTHS = { check: 34, num: 36, codigo: 100, tienda: 220 };
export const SPECIAL_COLUMN_WIDTHS = {
    ciudad: 160,
    pais: 130,
    estado: 120,
    apertura: 110,
    margen: 150,
    eurom2: 110,
    bloq: 90, // «Alertas» (antes «Bloq.»)
    pm: 170,
};
export const MIN_COLUMN_WIDTH = 60;

// Ancho por defecto de una columna: fija/especial por id; genérica por tipo de dato.
export function defaultColumnWidth(id, { type, unit } = {}) {
    if (FIXED_COLUMN_WIDTHS[id]) return FIXED_COLUMN_WIDTHS[id];
    if (SPECIAL_COLUMN_WIDTHS[id]) return SPECIAL_COLUMN_WIDTHS[id];
    if (type === "date") return 110;
    if (type === "number") return unit === "EUR" || unit === "EUR/m2" ? 130 : 100;
    return 150;
}

// Ancho total de la tabla (suma de columnas): con table-layout fixed y un ancho de tabla
// explícito, el navegador respeta los anchos de columna aunque el texto sea más largo.
export function tableWidth(ids, widthOf) {
    return ids.reduce((acc, id) => acc + widthOf(id), 0);
}

// Texto que muestra una columna genérica (mismo formato que su celda).
export function genericCellText(value, { type, unit } = {}, { formatDate, formatMoney, formatNumber }) {
    if (value == null || value === "") return "—";
    if (type === "date") return formatDate(value);
    if (type === "number") return unit === "EUR" || unit === "EUR/m2" ? formatMoney(Number(value)) : formatNumber(Number(value));
    return String(value);
}

// Ajuste al contenido (doble clic): texto más largo + extras de la celda (insignias,
// iconos) + relleno lateral, entre un mínimo y un máximo.
export function computeColumnWidth({ texts, measureText, overhead = 0, padding = 0, min = MIN_COLUMN_WIDTH, max = 640 }) {
    let widest = 0;
    const seen = new Set();
    texts.forEach((text) => {
        const key = String(text ?? "");
        if (seen.has(key)) return;
        seen.add(key);
        widest = Math.max(widest, measureText(key));
    });
    return Math.round(Math.min(max, Math.max(min, Math.ceil(widest + overhead + padding))));
}

// ¿Está recortado el texto de un elemento? (una línea con puntos suspensivos o varias
// líneas limitadas). Solo entonces se muestra el texto completo al pasar el ratón.
export function isTruncated({ scrollWidth, clientWidth, scrollHeight, clientHeight }) {
    return scrollWidth > clientWidth + 1 || scrollHeight > clientHeight + 1;
}
